import Sampler from '../sampler';

/* globals MediaRecorder */

const startRecordingString = 'Start recording';
const stopRecordingString = 'Stop recording';

let mediaRecorder;
let chunks;

export default {
  data () {
    return {
      buttonText: startRecordingString,
      isRecording: false
    };
  },

  computed: {
    buttonText () {
      return this.isRecording ? stopRecordingString : startRecordingString;
    },

    className () {
      const stateClass = this.isRecording ? ' recording' : '';

      return `recorder${stateClass}`;
    }
  },

  methods: {
    toggleRecordingStartStop () {
      if (this.isRecording) {
        this.stopRecording();
      } else {
        this.startRecording();
      }
    },

    startRecording () {
      chunks = [];
      mediaRecorder.start();
      this.isRecording = true;
    },

    stopRecording () {
      mediaRecorder.stop();
      this.isRecording = false;
    },

    loadRecording () {
      const fileReader = new FileReader();

      fileReader.onload = function (event) {
        Sampler.loadArrayBuffer(event.target.result);
      };

      fileReader.readAsArrayBuffer(new Blob(chunks));
    }
  },

  mounted () {
    navigator.getUserMedia(
      // constraints - only audio needed for this app
      {
        audio: true
      },
      stream => { // Success callback
        mediaRecorder = new MediaRecorder(stream);

        mediaRecorder.ondataavailable = function (e) {
          chunks.push(e.data);
        };

        mediaRecorder.onstop = this.loadRecording;
      },
      err => { // Error callback
        console.error('The following gUM error occured: ' + err); // eslint-disable-line
      }
   );
  }
};



// WEBPACK FOOTER //
// ./src/components/recorder/recorder.js